import { render, staticRenderFns } from "./_message.vue?vue&type=template&id=a035efd4"
import script from "./_message.vue?vue&type=script&lang=ts"
export * from "./_message.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports